import axios from '../services/axiosAuth';
import { initialize } from './dataLoadedActionsCreator';

export const initializeApp = () => (dispatch) => {
  axios
    .get('/pre_auth')
    .then(() => {
      dispatch(initialize('userInfo'));
      dispatch(initialize('salesman'));
      dispatch(initialize('cases'));
      dispatch(initialize('referrals'));
      dispatch(initialize('revenues'));
      dispatch(initialize('agents'));
      dispatch(initialize('customers'));
      dispatch(initialize('products'));
      dispatch(initialize('partnerArticles'));
      dispatch(initialize('brokerArticles'));
      dispatch(initialize('currentSettlement'));
      dispatch(initialize('repaymentPeriods'));
    })
};
